import * as React from 'react';

import * as dummyData from '../../../../utils/data';
import * as models from '../../../../utils/models';
import * as utils from '../../../../utils/utilities';

import css from '../pdf.module.scss';

interface VIAnomalyDataProps {
	data: models.VIReportItem[];
}

const VIAnomalyData: React.FC<VIAnomalyDataProps> = ({ data }) => {
	const riskLevels: models.RiskLevel[] = dummyData.getRiskLevels();

	return (
		<div className={css['pdf-anomaly-data']}>
			<div className="container-fluid overflow-hidden">
				{data.map((dataItem: models.VIReportItem) => {
					const style = utils.getItemStyle(dataItem);
					const riskLevel = utils.getRiskLevelFromName(dataItem.level);

					return (
						<div
							className={css['pdf-anomaly-data-item'] + ' row'}
							key={dataItem.id}
						>
							<div className="col-sm-6 p-0">
								<div className="container-fluid overflow-hidden">
									<div className="row">
										<div
											className={css['pdf-anomaly-data-item-box'] + ' col-4'}
										>
											Anomaly Category
										</div>
										<div className={css['pdf-anomaly-data-item-box'] + ' p-0'}>
											<div className="row w-100">
												{riskLevels.map((risk) => (
													<div className="col p-0" key={risk.level}>
														<div className={css['pdf-anomaly-data-item-box']}>
															{risk.level}
														</div>
														<div
															className={
																css['pdf-anomaly-data-item-box'] + ' text-white'
															}
															style={{ backgroundColor: risk.backgroundColor }}
														>
															{risk.backgroundColor}
														</div>
													</div>
												))}
											</div>
										</div>
									</div>
								</div>
								<div className="d-flex">
									<div className={css['pdf-anomaly-data-item-box']}>
										Anomaly #{dataItem.id}
									</div>

									<div
										className={css['pdf-anomaly-data-item-box']}
										style={style}
									>
										{dataItem.level}
									</div>
								</div>
								<div className="d-flex">
									<div className={css['pdf-anomaly-data-item-box']}>
										Recommendation
									</div>
									<div className={css['pdf-anomaly-data-item-box']}>
										<ul>
											{dataItem.recommendations.map((recommendation) => (
												<li key={recommendation.id}>{recommendation.name}</li>
											))}
										</ul>
									</div>
								</div>
								<div className={css['pdf-anomaly-data-item-box']}>
									Observation / Result
								</div>
								<div className={css['pdf-anomaly-data-item-box']} style={style}>
									<ul>
										{dataItem.observations.map((observation) => (
											<li key={observation.id}>{observation.name}</li>
										))}
									</ul>
								</div>
							</div>
							<div className="col-sm-6 p-3 border-dark">
								{dataItem.images
									.slice(0, 2)
									.map((image: models.PDFImageProps) => (
										<img
											key={image.caption}
											src={image.src}
											alt={image.caption}
											className={css['pdf-anomaly-data-item-image']}
											style={{ borderColor: riskLevel?.backgroundColor }}
										/>
									))}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default VIAnomalyData;
